export const profileTypeLabelMapping: Record<string, string> = {
  PERSONAL: 'Pessoal',
  LAWYER: 'Advogado',
  PUBLISHER: 'Fonte',
  COMPANY: 'Empresa',
  LAWYER_OFFICE: 'Escritório de Advocacia',
  EDUCATIONAL_INSTITUTION: 'Instituição de ensino',
  POLITICAL_PARTY: 'Partido Político',
  NGO: 'ONG',
}
